<template>
    <div class="mc-to-top display-none" ref="mc-to-top" :style="`left: ${left}px;right: ${right}px;top:${top}px;bottom: ${bottom}px`">
        <el-button type="primary" class="btn-to-top" size="mini" @click="$_goToTop">返回顶部</el-button>
    </div>
</template>

<script>
    export default {
        name: "mc-to-top",
        data(){
            return {
                scrollTop: null,
            }
        },
        props: {
            scrollContainer: {
                type: String,
                default: "index",
            },
            left: {
                type: Number,
                default: null,
            },
            right: {
                type: Number,
                default: 50,
            },
            top: {
                type: Number,
                default: null,
            },
            bottom: {
                type: Number,
                default: 30,
            },
        },
        methods: {
            $_goToTop(){
                document.getElementById(this.scrollContainer).scrollTop = 0;
            },
            $_handleScroll(){
                let SCROLL_TOP = document.getElementById(this.scrollContainer).scrollTop;
                if((SCROLL_TOP >= (document.getElementById(this.scrollContainer).clientHeight * 1.5)) && (SCROLL_TOP < this.scrollTop)) {
                    if(this.$refs["mc-to-top"].classList.contains("display-none")) {
                        this.$refs["mc-to-top"].classList.remove("display-none");
                    };
                } else {
                    if(!this.$refs["mc-to-top"].classList.contains("display-none")) {
                        this.$refs["mc-to-top"].classList.add("display-none");
                    }
                }
                this.scrollTop = SCROLL_TOP;
            },
        },
        mounted(){
            document.getElementById(this.scrollContainer).addEventListener('scroll', this.$_handleScroll, true);
        },
    }
</script>

<style lang="less" scoped>
    .mc-to-top {
        position: fixed;
        &.display-none {
            display: none;
        }
    }
    @media print {
        .mc-to-top {
            display: none;
        }
    }
</style>
